import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@app/core/services/user.service';
import { UserType } from '@app/core/utils/user-type';
import { BaseUserTypeGuard } from '@app/pcs/guards/base-user-type-guard';
import { Observable } from 'rxjs';

@Injectable()
export class UserTypeActivateGuard extends BaseUserTypeGuard  {

  constructor(protected userService: UserService) {
    super(userService);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const allowedUserTypes: UserType[] = route.data.allowedUserTypes;
    return this.hasPermission(allowedUserTypes);
  }

}
